/*
* @Author: reeqi
* @Date:   2016-06-17
* Created by NEXT of f2e@midea
*/

'use strict';


try{

//var $ = require('zepto');
var func = require('../module/func');
var Mustache = require('../../common/js/mustache');
var report = require("report");  //上报组件 
require('commonjs/zepto.mpopup.v2');

//var cookie = require("../../common/js/cookie");
//
//var login =require('mmd.common.pop_login').init();  //h5登录组件 
//S JM




var dialogTpl = require('../mustache/dialog.ma');


var miniProgram = require('../module/miniprogram');
var wx = require('weixin-js-sdk');//微信小程序sdk
window.IsWxMiniProgram = false;

var func = require('../module/func');
window.miniapp = func.getUrlParam('miniapp');  // 小程序类别，默认商城小程序midea,portal为会员小程序

var HasBinTipBtn = false;//是否绑定购物车跳小程序事件

var widgetVipcard = require('../module/widget.vipcard');
var widgetCouponlist = require('../module/widget.couponlist');
var widgetMiaoCouponlist = require('../module/widget.miao.couponlist');
var hasInitOnce = false;//已经初始化过了


var Swiper = require('swiper');
//E JM
var isLs = 0;

var mEventAppDomain = '';
if(window.location.host.indexOf('.littleswan.com') > -1){
  isLs = 1;
}
//add by  JasonM 2017-11-07
var isSH = 0;
if(window.location.host.indexOf('wx506caed3066ee044') > -1){//生活电器https://wx506caed3066ee044.midea.com/shop/index?fsid=1001097550297192
  isSH = 1;
}

var isDZ = 0;
if(window.location.host.indexOf('m.toshiba-lifestyle.cn') > -1){//东芝商城://m.toshiba-lifestyle.cn/shop/index?fsid=1001097550297192
  isDZ = 1;
}

var shop_type = 11;
if(isLs){
  shop_type = 1;
}
if(isSH){
  shop_type = 2;
}
if(isDZ){
  shop_type = 3;
}
window.shop_type = shop_type;
window.isLs = isLs;
if(isLs){
  var login = require('lsm.common.pop_login').init();
  mEventAppDomain = '//m.littleswan.com';
}else{
  var login = require('mmd.common.pop_login').init();
  mEventAppDomain = '//w.midea.com';
}
//add by  JasonM 2017-11-07
if(isSH){
  var login = require('mmd.common.pop_login').init();
  mEventAppDomain = '//wx506caed3066ee044.midea.com';
}
if(isDZ){
  var login = require('mmd.common.pop_login').init();
  mEventAppDomain = 'm.toshiba-lifestyle.cn';
}


var countObj=require('commonjs/act.count.down.v2');

var  aTime={},countDown={};
var fsid = func.getUrlParam('fsid');

//小天鹅商城的fsid:
if(isLs){
  fsid = '1002953470295277';
}
if(!fsid){
    fsid = false;
}
//add by  JasonM 2017-11-07
if(isSH){//生活电器的fsid
  fsid = '1001097550297192';
}
if(isDZ){
  fsid = '1003089850308984';
}
window.fsid = fsid;
function iosFixedDate(strDatetime){
  return strDatetime ? strDatetime.replace(/-/g,'/') : '';
};

var product = {

  getPrice : function(){
    var $priceDOM = $('.js-widget-price');
    if($priceDOM.length > 0){
      var skuidArr = [];
      $priceDOM.each(function(index, el) {
        
        if($(el).attr('data-price-type') == 2){
            func.getGoodsActData({
                skuId:$(el).attr('data-goods-skuid'),
                activeId:$(el).attr('data-activeid'),
            },function(data){
                var price = data.data[$(el).attr('data-goods-skuid')]?data.data[$(el).attr('data-goods-skuid')][0].lActiveFee/100:'';
                $(el).html(price);

            });
            
        }else{
          skuidArr.push($(el).attr('data-goods-skuid'));

          
             
        }
        if(skuidArr.length> 0){
              console.log(skuidArr);
            func.getGoodsData(skuidArr,function(data){
                console.log(data);
              for(var i in data){
                var price = parseInt(data[i].nSalePrice);
                console.log(i);
                $('.js-widget-price[data-goods-skuid="'+ i +'"]').html(price);
              }
            });
          }
      });
      // if(skuidArr.length > 0){

        
      // }
    }
  },
  updateLink : function(){
    $('.js-widget-link,.widget_link').each(function(index, el) {
      var $link = $(el).find('.link_a');
      var href = $link.attr('href');
      //modify by  JasonM 2017-11-07
      if(!isLs){
        var newHref = func.updateUrl(href);
        $link.attr('href',newHref);
      }

    });
  },


  init : function(){
    this.getPrice();
    //this.updateLink();
      // if(fsid){
      //     this.updateLink();
      // }

  }
};
var lazy = {
  updateImage : function(){
    var _self = this;
    this.$willBgItems.each(function(i,el){

        if ($(el).data('lazy').length>0 && $(el).data('lazy')!=el.src){
            if (_self.topArray[i]<$(window).scrollTop()+_self.$willDistance){

                $(el).attr('src',$(el).data('lazy'));
            }
        }
    });
  },

  renderPoolList : function(){
    var _self = this;
    this.$willPoolList.each(function(i,el){
        if($(el)[0].innerHTML === ''){
            if (_self.poolArray[i]<$(window).scrollTop()+_self.$willDistance){
                var taoIdType = $(el).attr('data-tao-id-type') ? $(el).attr('data-tao-id-type') : 'pool';
                var poolId = $(el).attr('data-pool-id');
                var poolLen = $(el).attr('data-pool-len');
                var poolTpl = $(el).attr('data-pool-tpl');
                var proPrice = $(el).attr('data-pro-price');
                var perPoolLen = parseInt($(el).attr('data-per-pool-len'));
                var isMore = $(el).attr('data-is-more');
                //var fsid = func.getUrlParam('fsid');
                // func.getPoolsData(poolId,poolLen,fsid,isLs,function(data){//根据isLs配置url,改为shop_type： 1小天鹅 2生活电器 3东芝H5 ,区分是小天鹅还是生活电器还是其他
                  func.getPoolsData(poolId,poolLen,fsid,shop_type,proPrice,function(data){
                    data.forEach((item,index)=>{
                    if(item.vecSellStageList){
                          item.stage1Limit = item.vecSellStageList[0]?item.vecSellStageList[0].lStageNum:'';
                          item.stage1Price = item.vecSellStageList[0]?item.vecSellStageList[0].lstagePrice:'';
                          item.stage2Limit = item.vecSellStageList[1]?item.vecSellStageList[1].lStageNum:'';
                          item.stage2Price = item.vecSellStageList[1]?item.vecSellStageList[1].lstagePrice:'';
                          item.stage3Limit = item.vecSellStageList[2]?item.vecSellStageList[2].lStageNum:'';
                          item.stage3Price = item.vecSellStageList[2]?item.vecSellStageList[2].lstagePrice:'';
                      }
                    });
                  var output = Mustache.render(poolTpl, {data:data});
                  $(el).html(output);
                  if(isMore == 1){//查看更多处理
                     $(el).find('.mc_product_item,.product_major_item').each(function(index,item){
                         $(el).attr('data-page-num', 1);//当前页数
                         if(index>=perPoolLen){
                             $(item).css('display','none');

                         }
                     });
                  }
                  $(el).removeAttr('data-pool-tpl');
                  lazy.init_bg();
                  if($('#eventLift').length > 0){
                    lift.updateFloorTop();
                    // lift.clickLiftItem();
                  }
                },{taoIdType:taoIdType});


            }


        }
    });



  },


  init_bg : function(){

    var _self = this;
    var $willBgItems= $('[data-lazy]');
    this.$willDistance = $(window).height()*2.5;
    if ($willBgItems.length>0){
        var topArray=[];

        $willBgItems.each(function(i,el){
            topArray[i]=$(el).offset().top;
        });
        this.$willBgItems = $willBgItems;
        this.topArray = topArray;

        this.updateImage();

        $(window).bind('scroll', function (event) {

          func.throttle(_self.updateImage,_self);
        });
    }


  },


  init_pool : function(){
    var _self = this;
    var $willPoolList = $('[data-pool-lazy]');

    if ($willPoolList.length>0){
        var poolArray=[];
        $willPoolList.each(function(i,el){
            poolArray[i]=$(el).offset().top;
        });
        this.$willPoolList = $willPoolList;
        this.poolArray = poolArray;

        this.renderPoolList();

        $(window).bind('scroll', function (event) {

          func.throttle(_self.renderPoolList,_self);
        });
    }


  }
};

var $mask=$('.black_cover');
var coupon={  //优惠券领取，PC和h5有些不一样

    popAll:function(popId) {
      console.log(navigator.userAgent);
      if(navigator.userAgent.indexOf('baiduboxapp')>=0){//兼容手机百度
        console.log('baiduboxapp');
        $mask[0].style.display = 'block';
        $('#' + popId)[0].style.display = 'block';
        console.log($mask[0].style.display);
      }else{
        console.log('not baiduboxapp');
        $mask.addClass('open');
        $('#' + popId).addClass('open');
      }
        
    },
    getGeneralCoupon:function(){
        $('.floor').on('click','.js_widget_coupon,.js_item_coupon,.js_widget_coupon_yuyue', function (e) {
          e.preventDefault();
            var $coupon=$(this);
            
            var obtainId =$coupon.data('oid');
//            report.rd({"mtag": $coupon.data("mtag")});
            var isYuyue = false;
            if($coupon.hasClass('js_widget_coupon_yuyue')){
              isYuyue = true;
            }
            login.start(function(){
                $.ajax({
                    type: 'GET',
                    url: '/coupon/get_user_coupon',
                    data: {obtainId: obtainId},
                    timeout: 10000,
                    dataType: 'json',
                    success:function(data){
                        var errCode=data.errcode;
                        if(navigator.userAgent.indexOf('baiduboxapp')>=0 && navigator.userAgent.indexOf('Android')>=0){
                          if (errCode == 0) {
                              if(!isYuyue){
                                // coupon.popAll('getSuc');
                                alert('领取成功~');
                              }else{
                                // coupon.popAll('getYuyueSuc');
                                alert('预约成功~');
                              }
                          } else if (errCode == 549064771) {  //还没到领取时间
                              // coupon.popAll('getNotTime');
                              alert('还没到领取时间~');
                          }else if (errCode == 549064739) {  //已抢过
                              if(!isYuyue){
                                // coupon.popAll('getDone');
                                alert('您已领取过~');

                              }else{
                                // coupon.popAll('getYuyueDone');
                                alert('您已预约过~');
                              }

                          }else if (errCode == 549064758 || errCode == 549064802) {  //已抢光 | 已暂停
                              // coupon.popAll('getNone');
                              alert('已抢光~');
                          }else {
                            alert('系统繁忙~');
                              // coupon.popAll('getFailed');   //领券过于频繁，系统繁忙
                          }
                        }else{
                          if (errCode == 0) {
                              if(!isYuyue){
                                coupon.popAll('getSuc');
                              }else{
                                coupon.popAll('getYuyueSuc');
                              }
                          } else if (errCode == 549064771) {  //还没到领取时间
                              coupon.popAll('getNotTime');
                          }else if (errCode == 549064739) {  //已抢过
                              if(!isYuyue){
                                coupon.popAll('getDone');
                              }else{
                                coupon.popAll('getYuyueDone');
                              }

                          } else if (errCode == 549068803) {  //不是付费会员
                            coupon.popAll('getNotProMember');
                          } else if (errCode == 549068804) {  //等级不满足条件
                                coupon.popAll('getNotLevel');
                          }else if (errCode == 549064758 || errCode == 549064802) {  //已抢光 | 已暂停
                              coupon.popAll('getNone');
                          }else {
                              coupon.popAll('getFailed');   //领券过于频繁，系统繁忙
                          }  
                        }
                        
                    },
                    error:function(){
                        coupon.popAll('getFailed');


                    }
                });
            },function(){


            });

        });



    },

    closeLayerFun:function(){
        


    },
    init : function(){
        this.getGeneralCoupon();
        this.closeLayerFun();
    }
};

var cart={  //加入购物车，PC和h5有些不一样
    popAll:function(popId,type,title,content,btnHtml) {
        $mask.addClass('open');
        var that = $('#' + popId);
        that.find('.js_tips_ico').removeClass('success').addClass(type);
        that.find('.js_title').html(title);
        that.find('.js_content').html(content);
        that.find('.js_btn_box').html(btnHtml).find('.ok_btn,.check_btn').off().on('click',function(){
            that.find('.close').click();
        });
        that.addClass('open');
    },
    addItemToCart:function(){
        $('.js_widget_cart').on('click', function (e) {
          e.preventDefault();
          var title ='加入购物车成功',
              $cart = $(this),
              skuid = $cart.data('skuid'),
              subtitle = $cart.data('subtitle');

              if(isLs || isSH || isDZ){
                var fsid = fsid;
              }else{
                var fsid = '1000000000100511';
              }
          login.start(function(){
              $.ajax({
                  type: 'POST',
                  url: '/cart/index/ajax_add_item',
                  data: {
                      num: 1,
                      itemid: '' + fsid + skuid
                  },
                  timeout: 10000,
                  dataType: 'json',
                  success: function (data) {
                      if (data.errcode == 0) {
                          cart.popAll('popTips','success',title,subtitle,'<a href="javascript:;" class="tip_btn ok_btn">再逛逛</a><a target="_blank" href="'+ mEventAppDomain +'/cart?fsid=' + fsid + '" class="tip_btn check_btn" >前往购物车</a>');
                          // 绑定事件兼容跳转小程序
                          if(window.IsWxMiniProgram && !HasBinTipBtn){//微信小程序
                            miniProgram.bindTipBtnEvent();
                            HasBinTipBtn = true;
                          }
                      } else if(data.errcode == 0x21531004){//购物车已满
                          cart.popAll('popTips','','加入购物车失败',data.errmsg,'<a href="javascript:;" class="tip_btn ok_btn">知道了</a><a target="_blank" href="'+ mEventAppDomain +'/cart?fsid=' + fsid + '" class="tip_btn check_btn" >整理购物车</a>');
                      } else if(data.errcode == 559091715){//商品不存在
                          cart.popAll('popTips','','加入购物车失败','该商品可能已下架或不存在','<a href="javascript:;" class="tip_btn ok_btn">看看别的商品</a>');
                      } else{
                          cart.popAll('popTips','','加入购物车失败',data.errmsg,'<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
                      }
                  },
                  error: function () {
                      cart.popAll('popTips','','加入购物车失败','网络繁忙，请稍后再试','<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
                  }
              },function(){


              });
          });
        });
    },
    addGoodsListItemToCart:function(){
      var that = this;
      $('.js-pool-goodslist').on('click','.js_goods_add_cart', function (e) {
        e.preventDefault();
        var title ='加入购物车成功',
            $cart = $(this),
            itemid = $cart.data('itemid'),
            subtitle = '1件商品已成功加入您的购物车';

            if(isLs || isSH || isDZ){
              var fsid = fsid;
            }else{
              var fsid = '1000000000100511';
            }
        login.start(function(){
            $.ajax({
                type: 'POST',
                url: '/cart/index/ajax_add_item',
                data: {
                    num: 1,
                    itemid: itemid
                },
                timeout: 10000,
                dataType: 'json',
                success: function (data) {
                    if (data.errcode == 0) {
                      that.showCartNum();
                      $.mpopup({
                        type: 'info',
                        contentTxt: '加入购物车成功',
                        icoType: 'right',
                        autoClose:1000,
                        mask: true,
                      }).show();                  
                      //cart.popAll('popTips','success',title,subtitle,'<a href="javascript:;" class="tip_btn ok_btn">再逛逛</a><a target="_blank" href="'+ mEventAppDomain +'/cart?fsid=' + fsid + '" class="tip_btn check_btn" >前往购物车</a>');
                      // 绑定事件兼容跳转小程序
                      if(window.IsWxMiniProgram && !HasBinTipBtn){//微信小程序
                        miniProgram.bindTipBtnEvent();
                        HasBinTipBtn = true;
                      }
                    } else if(data.errcode == 0x21531004){//购物车已满
                      $.mpopup({
                        type: 'info',
                        contentTxt: '购物车已满',
                        icoType: 'error',
                        autoClose:1000,
                        mask: true,
                      }).show();                         
                        //cart.popAll('popTips','','加入购物车失败',data.errmsg,'<a href="javascript:;" class="tip_btn ok_btn">知道了</a><a target="_blank" href="'+ mEventAppDomain +'/cart?fsid=' + fsid + '" class="tip_btn check_btn" >整理购物车</a>');
                    } else if(data.errcode == 559091715){//商品不存在
                      $.mpopup({
                        type: 'info',
                        contentTxt: '商品不存在',
                        icoType: 'error',
                        autoClose:1000,
                        mask: true,
                      }).show();  
                      //cart.popAll('popTips','','加入购物车失败','该商品可能已下架或不存在','<a href="javascript:;" class="tip_btn ok_btn">看看别的商品</a>');
                    } else{
                        $.mpopup({
                          type: 'info',
                          contentTxt: '加入购物车失败:' + data.errmsg,
                          icoType: 'error',
                          autoClose:1000,
                          mask: true,
                        }).show();                       
                        //cart.popAll('popTips','','加入购物车失败',data.errmsg,'<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
                    }
                },
                error: function () {
                  $.mpopup({
                    type: 'info',
                    contentTxt: '网络繁忙，请稍后再试',
                    icoType: 'error',
                    autoClose:1000,
                    mask: true,
                  }).show();                    
                    //cart.popAll('popTips','','加入购物车失败','网络繁忙，请稍后再试','<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
                }
            },function(){


            });
        });
      });
    },    
    addTaoZhuangToCart:function(){
      $('.js-pool-goodslist').on('click','.js_tao_buy_btn', function (e) {
        e.preventDefault();
        var title ='加入购物车成功',
            $cart = $(this),
            items = $cart.data('allitemids').split(','),
            act_id = $cart.data('active-id'),
            subtitle = items.length + '件商品已加入您的购物车';
        login.start(function(){
            $.ajax({
                type: 'POST',
                url: '/cart/index/ajax_add_item',
                data: {
                  num: 1,
                  act_id : act_id,
                  act_type: 7,                        
                  itemid: items[0]
                },
                timeout: 10000,
                dataType: 'json',
                success: function (data) {
                    if (data.errcode == 0) {
                        cart.popAll('popTips','success',title,subtitle,'<a href="javascript:;" class="tip_btn ok_btn">再逛逛</a><a target="_blank" href="'+ mEventAppDomain +'/cart?fsid=' + fsid + '" class="tip_btn check_btn" >前往购物车</a>');
                        // 绑定事件兼容跳转小程序
                        if(window.IsWxMiniProgram && !HasBinTipBtn){//微信小程序
                          miniProgram.bindTipBtnEvent();
                          HasBinTipBtn = true;
                        }
                    } else if(data.errcode == 0x21531004){//购物车已满
                        cart.popAll('popTips','','加入购物车失败',data.errmsg,'<a href="javascript:;" class="tip_btn ok_btn">知道了</a><a target="_blank" href="'+ mEventAppDomain +'/cart?fsid=' + fsid + '" class="tip_btn check_btn" >整理购物车</a>');
                    } else if(data.errcode == 559091715){//商品不存在
                        cart.popAll('popTips','','加入购物车失败','该商品可能已下架或不存在','<a href="javascript:;" class="tip_btn ok_btn">看看别的商品</a>');
                    } else{
                        cart.popAll('popTips','','加入购物车失败',data.errmsg,'<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
                    }
                },
                error: function () {
                    cart.popAll('popTips','','加入购物车失败','网络繁忙，请稍后再试','<a href="javascript:;" class="tip_btn ok_btn">知道了</a>');
                }
            },function(){


            });
        });
      });
  },
  cartIcon : function(){
    $('.js_acrt').on('click',function(e){
      if(window.location.search.indexOf('appview=1') > -1){
        e.preventDefault();

        login.start(function(){
          window.location.href = 'https://m.midea.cn/cart';
        })
      }      
    })

  },
  showCartNum : function(){
    $.ajax({
      type: 'GET',
      url: '/my/index/ajax_index_cart_num',
      timeout: 10000,
      dataType: 'json',
      success: function (data) {
          if(data.errcode == 0){
            if(data.data.nRedDot && data.data.nCount){
              $('#cartNum').show();
              $('#cartNumInner').text(data.data.nCount);
            }
          }
      },
      error: function () {

      }
    });
  },

    init : function(){
        this.addItemToCart();
        this.addTaoZhuangToCart();
        this.addGoodsListItemToCart();
        this.showCartNum();
        this.cartIcon();
    }
};


var rule = {


  event : function(){
    $('.js-rule-header').on('click',function(e){
      $(this).parent().toggleClass('rule-unfold');
    })

  },
  init : function(){
    this.event();
  }
}



var lift = {
  isClickItem:false,
  switchLiftCurrent : function(){
    var _self = this;
    if(_self.isClickItem){//点击不触发滚动
      _self.isClickItem = false;
      return;
    }
    for (var i = 0; i < this.floorIdArr.length; i++) {
      // console.log(_self.floorTopArr[i],$(window).scrollTop())
      if(parseInt(_self.floorTopArr[i])<=($(window).scrollTop()+10)){
        // console.log($('#eventLift a').parent(),$('#eventLift a').parent().removeClass('event_mod_lift_item_cur').eq(i));
        $('#eventLift a').parent().removeClass('event_mod_lift_item_cur').eq(i).addClass('event_mod_lift_item_cur');
        if(Math.floor(i/4)>0){
          document.querySelector('#eventLift').scrollTo(Math.floor(i/4)*80,0);
          // $('#eventLift').css({width:`${83*$('#eventLift a').parent().length}`,'transform': `translate3d(-${$('#eventLift a').parent().eq(i).offset().left}px, 0px, 0px)`});
        }
        console.log($('#eventLift a').parent().eq(i));
        if($('.lift-data-list').length>0){
          $('.lift-data-list a').parent().removeClass('event_mod_lift_item_cur').eq(i).addClass('event_mod_lift_item_cur');
        }
        
      }
    }

  },

  getLiftFloor : function(){
    var floorIdArr = [];
    $('#eventLift a').each(function(index,elem){
      var href = $(elem).attr('href');
      if(href.indexOf('#') == 0){
        floorIdArr.push(href);
      }
    });

    this.floorIdArr = floorIdArr;

  },

  updateFloorTop : function(){

    var floorTopArr = [];

    for (var i = 0; i < this.floorIdArr.length; i++) {
      console.log(i);
      var id = this.floorIdArr[i];
      var top;
      var $floor = $(id);
      if($floor.length > 0){
        top = $floor.offset().top;
        floorTopArr.push(top);
      }
      
    }

    this.floorTopArr = floorTopArr;
  },

  clickLiftItem : function(){
    var $liftLink = $('#eventLift a');
    var _self = this;
    $liftLink.off('click').on('click',function(e){
      _self.isClickItem = true;
      $('#eventLift a').parent().removeClass('event_mod_lift_item_cur');
      $(this).parent().addClass('event_mod_lift_item_cur');
      if($('.lift-data-list').length>0){
        //联动
        $('.lift-data-list a').parent().removeClass('event_mod_lift_item_cur');
        $('.lift-data-list').find('a[href="'+$(this).attr('href')+'"]').parent().removeClass('event_mod_lift_item_cur').addClass('event_mod_lift_item_cur');
      }
      

    })
    if($('.lift-data-list').length>0){//新模板
      var $liftLink = $('.lift-data-list a');
      var _self = this;
      $liftLink.off('click').on('click',function(e){
        _self.isClickItem = true;
        $liftLink.parent().removeClass('event_mod_lift_item_cur');
        $(this).parent().addClass('event_mod_lift_item_cur');
        // $('#eventLift').css({'transform': `translate3d(-${$(this).parent().offset().left}px, 0px, 0px)`});
        //联动
        $('#eventLift a').parent().removeClass('event_mod_lift_item_cur');
        $('#eventLift').find('a[href="'+$(this).attr('href')+'"]').parent().removeClass('event_mod_lift_item_cur').addClass('event_mod_lift_item_cur');
      });
      $('.js_show_overlayer').off('click').on('click',function(e){
        if(!$(this).parents('.event_mod_lift_style_3').hasClass('show')){
          
          $(this).parents('.event_mod_lift_style_3').addClass('show');
        }else{
          
          $(this).parents('.event_mod_lift_style_3').removeClass('show');
        }
      });
    }
  },


  init : function(){
    var _self = this;
    if($('#eventLift').length > 0){
      $('#eventLift').parents('.floor').css('z-index',4);//修复fixed层级
      this.getLiftFloor();
      this.updateFloorTop();
      this.clickLiftItem()
      $(window).bind('scroll', function (event) {
        func.throttle(_self.switchLiftCurrent,_self);
      });
    }

  }
}
/*
* add by JasonM 20171120
*
*
*/
var giftPack={  //礼包领取，PC和h5有些不一样
    sendGiftRequest : false,
    popAll:function(popId) {
        $mask.addClass('open');
        $('#' + popId).addClass('open');
    },
    getGeneralgiftPack:function(){
        var _this=this;
        $('.js_widget_gift_package').on('click', function (e) {
          e.preventDefault();
          var _selfEle = $(this);
          login.start(function(){
            if(_this.sendGiftRequest){
                return;
            }
            _this.sendGiftRequest=false;
            var gid=_selfEle.attr('data-gid');
            $.ajax({
                url:'/promote/w/mabapp/get_user_gift',
                type:'post',
                dataType:'json',
                data:{gid:gid},
                success:function(data){
                    if(data.errcode==0){
                        // $mask.show();
                        // $('layerSuccess').show();
                        _this.popAll('getGiftSuccess');
                    }else if(data.errcode==3){//等级不够
                        // $mask.show();
                        // $('layerDisable').show();
                        _this.popAll('getGiftNotLevel');
                    }else if(data.errcode==4) {//
                        // $mask.show();
                        // $('layerAlready').show();
                        _this.popAll('getGiftHasGain');
                    }else if(data.errcode==539299861) {//登录信息失效
                        // $mask.show();
                        // $('layerAlready').show();
                        _this.popAll('getGiftUserInfoErr');
                    }else{
                        // $mask.show();
                        // $('#layerGiftError').show();
                        _this.popAll('getGiftError');
                    }
                    _this.sendGiftRequest=false;
                },
                error:function(){
                    _this.popAll('getGiftError');
                    _this.sendGiftRequest=false;
                }

            });
            },function(){

            });
        });
    },

    closeLayerFun:function(){
        $('.close,.ok_btn').on('click', function () {
          if(navigator.userAgent.indexOf('baiduboxapp')>=0){
            $(this).parents('.open_tips').css({'display':'none'});
            $mask.css({
              'display':'none'
            });;
          }else{
            $(this).parents('.open_tips').removeClass('open');
            $mask.removeClass('open');  
          }
          
        });

        $('.i_close').on('click',function(){
          if(navigator.userAgent.indexOf('baiduboxapp')>=0){
              $('.open_tips_img').hide();
              $mask.css({'display':'none'});
          }else{
              $('.open_tips_img').hide();
              $mask.removeClass('open');
          }
          
        });

        $('.black_cover').on('click',function(){
          if(navigator.userAgent.indexOf('baiduboxapp')>=0){
            $('.open_tips_img').hide();
            $('.open_tips').css({'display':'none'});
            $mask.css({'display':'none'});
          }else{
            $('.open_tips_img').hide();
            $('.open_tips').removeClass('open');
            $mask.removeClass('open');
          }
            
        });

    },
    gotoLogin(){
      $(document).on('click','.js_goto_login',function(){
        if(window.IsWxMiniProgram){
          let hashs = location.href.split('/');
          let id = hashs[hashs.length];
          let navigateUrl = '/page/login/login?page=' + encodeURIComponent('/page/web_view_promote/web_view_promote?id='+id);
          wx.miniProgram.navigateTo({
            url:navigateUrl,
          });
        }else{
          window.location.href = '/mlogin/web_login?rurl=' + encodeURIComponent(location.href);
        }
      })
    },
    init : function(){
        this.getGeneralgiftPack();
        this.closeLayerFun();
        this.gotoLogin();
    }
};
var linkPopLayer = {
  eventBind:function(){
    $(document).on('click','.js_widget_pop_layer',function(e){
      if($('.md-popup').length==0){
        var data = {
          title:'',
          content:$(this).attr('data-content'),
          btnConfirmTxt:'知道啦~',
        };
        var output = dialogTpl(data);
        $('body').append(output);
      }else if($('.md-popup').length>0){
        $('.md-popup-text').html($(this).attr('data-content'));
        $('.md-popup').addClass('md-popup-in');
        $('.md-popup-backdrop').addClass('md-active');
      }
      
    })
    $(document).on('click','.md-popup-button.confirm',function(){
      $('.md-popup').removeClass('md-popup-in');
      $('.md-popup-backdrop').removeClass('md-active');
    })
    $(document).on('click','.more-btn-box',function(){

        let $el = $(this).parents('.js-pool-goodslist');
        var poolLen = parseInt($el.attr('data-pool-len'));
        var perPoolLen = parseInt($el.attr('data-per-pool-len'));//初始长度
        var isMore = $el.attr('data-is-more');
        var pageNum = parseInt($el.attr('data-page-num'));
        // if((pageNum * perPoolLen) >= poolLen){
        //     $(this).text('暂无更多数据').css('opacity',0.4);
        // }else{
            // pageNum += 1;
            $el.find('.mc_product_item,.product_major_item').each(function(index,item){
                if($(item).css('display') == 'none'){
                    $(item).css('display','block');
                }
            });
            $(this).hide();
            // $el.attr('data-page-num',pageNum);
        // }
        

    });
  },
  init:function(){
    this.eventBind();
  }
}


/**
 * 新秒杀模块
 *
 */
var miaoV2 = {
  
    // 抢购开始
    timeStart:function(t, _ele){
         _ele.find('.js_miao_item').each(function(){
            let $li = $(this);
            if($(this).data('state')==4){
                miaoV2.timeOver(t,$(this),_ele); // 抢光
                $li.find('.mc_btn_will_start').addClass('hide');
                $(this).countDown && clearInterval($(this).countDown.timeInterVal);

            }else{
                // clearInterval(t.obj.timeInterVal);
                
                // miaoV2.timeStart(t,$(this),_ele);//立即开抢
                 if($li.hasClass("js_sec_section")){
                    _ele.find('.js_sec_section').removeClass("mc_sec_will_start ").removeClass("mc_sec_over ").addClass("mc_sec_on_going");
                    _ele.find('.js_sec_section').find(".mc_btn_on_going").find('.mc_des').html('立即秒杀<i class="mc_icon_arrow mc_icon_arrow_white"></i>');
                }else{
                    //商品状态变化
                    $li.removeClass(" mc_pro_will_start").removeClass(" mc_pro_over").addClass("mc_pro_on_going");
                    // $li.find(".mc_btn_on_going").find('.mc_des').html('<span class="mc_des">立即秒杀<i class="mc_icon_arrow"></i>');
                    $li.find(".mc_btn").addClass('hide');
                }
                $li.find(".mc_btn_on_going").removeClass('hide');
                $li.find(".mc_btn_on_going").find('.mc_des').html('立即秒杀');
                $li.find('.mc_btn_will_start').addClass('hide');
                var $count=_ele.find('.js_miao_count');

                $count.find('.js_count_d').text(t.days);
                $count.find('.js_count_d').text(t.days);
                $count.find('.js_count_h').text(t.hours);
                $count.find('.js_count_m').text(t.minutes);
                $count.find('.js_count_s').text(t.seconds);
            }
        });
    },
    //时间小于30min
    timeBefore:function(t,_ele){
        //抢券状态变化 样式 按钮 link
        _ele.find('.js_sec_section').removeClass("mc_sec_over").removeClass("mc_sec_on_going").addClass("mc_sec_will_start");
        // _ele.find('.js_sec_section').find(".mc_btn_will_start").find('.mc_des').html("即将开始");
        //商品状态变化
        _ele.find('.js_goods_section').each(function(){
            var $li=$(this);
            $li.removeClass("mc_pro_over").removeClass("mc_pro_on_going").addClass("mc_pro_will_start");
            $li.find(".mc_btn_will_start").find('.mc_des').html("即将开始");
            $li.find(".mc_btn").addClass('hide');

        });
        _ele.find(".mc_btn_will_start").removeClass('hide');
        _ele.find(".mc_btn_will_start").find('.mc_des').html('即将开始');
        //倒计时 时间数字变化
        var $count=_ele.find('.js_miao_count');
        $count.find('.js_count_d').text(t.days);
        $count.find('.js_count_h').text(t.hours);
        $count.find('.js_count_m').text(t.minutes);
        $count.find('.js_count_s').text(t.seconds);
    },
    //时间大于30min 未开始
    timeBeforeLong:function(t,_ele){
        //抢券状态变化 样式 按钮 link
        _ele.find('.js_sec_section').removeClass("mc_sec_over").removeClass("mc_sec_on_going").addClass("mc_sec_will_start");
        // _ele.find('.js_sec_section').find(".mc_btn_will_start").find('.mc_des').html("未开始");
        //商品状态变化
        _ele.find('.js_goods_section').each(function(){
            var $li=$(this);
            // $li.removeClass("mc_pro_over").removeClass("mc_pro_on_going").addClass("mc_pro_will_start");
            $li.find(".mc_btn_will_start").find('.mc_des').html("未开始");
            $li.find(".mc_btn").addClass('hide');

        });
        _ele.find(".mc_btn_will_start").removeClass('hide');
        _ele.find(".mc_btn_will_start").find('.mc_des').html('未开始');
        //倒计时 时间数字变化
        var $count=_ele.find('.js_miao_count');
        $count.find('.js_count_d').text(t.days);
        $count.find('.js_count_h').text(t.hours);
        $count.find('.js_count_m').text(t.minutes);
        $count.find('.js_count_s').text(t.seconds);

    },
    //抢光了
    timeOver:function(t,$li,_ele){
        if($li.hasClass("js_sec_section")){
            _ele.find('.js_sec_section').removeClass("mc_sec_will_start ").removeClass("mc_sec_on_going").addClass("mc_sec_over");
            _ele.find('.js_sec_section').find(".mc_btn_over").find('.mc_des').html("已抢光");
            _ele.find('.js_sec_section').find(".mc_btn_over").find('.mc_des').css("background","#999");
        }else{
            //商品状态变化
            $li.removeClass(" mc_pro_will_start").removeClass("mc_pro_on_going").addClass("mc_pro_over");
            // $li.find(".mc_btn_over").find('.mc_des').html("已抢光");
            $li.find(".mc_btn").addClass('hide');
        }
        _ele.find(".mc_btn_will_start").addClass('hide');
        $li.find(".mc_btn_sold_over").removeClass('hide');
        $li.find(".mc_btn_sold_over").find('.mc_des').html('已抢光');
        $li.find('.mc_modal_over').addClass('hide');
        $li.find('.mc_modal_sold_over').removeClass('hide');
        //倒计时 时间数字变化
        var $count=_ele.find('.js_miao_count');
        // $count.find('.js_count_d').text('0');
        // $count.find('.js_count_h').text('0');
        // $count.find('.js_count_m').text('0');
        // $count.find('.js_count_s').text('0');
        $count.find('.js_count_d').text(t.days);
        $count.find('.js_count_h').text(t.hours);
        $count.find('.js_count_m').text(t.minutes);
        $count.find('.js_count_s').text(t.seconds);
    },
    timeEnd(t,_ele){//已结束
        _ele.find('.js_sec_section').removeClass("mc_sec_over").removeClass("mc_sec_on_going").addClass("mc_sec_will_start");
        // _ele.find('.js_sec_section').find(".mc_btn_will_start").find('.mc_des').html("已结束");
        //商品状态变化
        _ele.find('.js_goods_section').each(function(){
            var $li=$(this);
            $li.removeClass("mc_pro_over").removeClass("mc_pro_on_going").addClass("mc_pro_will_start");
            // $li.find(".mc_btn_will_start").find('.mc_des').html("即将开始");
            $li.find(".mc_btn").addClass('hide');

        });
        _ele.find(".mc_btn_over").removeClass('hide');
        _ele.find(".mc_btn_over").find('.mc_des').html('已结束');
        _ele.find('.mc_modal_over').addClass('hide');
        _ele.find('.mc_modal_time_over').removeClass('hide');
        _ele.find('.mc_modal_time_over').css('display','block');
        _ele.find('.js_sec_section').find(".mc_btn_sold_over").addClass('hide');//结束则隐藏已抢光按钮
        //倒计时 时间数字变化
        var $count=_ele.find('.js_miao_count');
        $count.find('.js_count_d').text('0');
        $count.find('.js_count_h').text('0');
        $count.find('.js_count_m').text('0');
        $count.find('.js_count_s').text('0');
    },
    timeCallback: function(t, _ele){
        
        if(t.total > 30 *60*1000){ // 距离开始大于30分钟，显示未开始
            miaoV2.timeBeforeLong(t,_ele);

        } else if(t.total > 0){ // 距离开始30分钟以内，显示即将开始
            miaoV2.timeBefore(t,_ele);

        } else if(t.total <= 0){

            var nextEndTime;
            let myMiaoServerTime = new Date(func.timestampToTime(parseInt(window.miaoServerTime))).getTime();

            if(_ele.attr('data-miao-time-nav-type') == '1'){ // 日期类型秒杀，优先取endtime,无则使用当天 23:59 作为倒计时终点
                let $dateli = _ele.find('.nav_date_li.active');
                if($dateli.attr('data-endtime')){
                    nextEndTime = iosFixedDate($dateli.attr('data-date') + ' ' + $dateli.attr('data-endtime'));
                }else{
                    nextEndTime = iosFixedDate($dateli.attr('data-date') + ' 23:59:59');
                }
                

            } else if (_ele.attr('data-miao-time-nav-type') == '2'){ // 时间类型秒杀 优先取endtime,无则使用当天 23:59 作为倒计时终点
                let $timeli = _ele.find('.nav_time.active');
                if($timeli.attr('data-endtime')){
                    nextEndTime = iosFixedDate($timeli.attr('data-date') + ' ' + $timeli.attr('data-endtime'));
                }else{
                    nextEndTime = iosFixedDate($timeli.attr('data-date') + ' 23:59:59');
                }

            } else { // 日期时间类型秒杀，以当前时段的终点作为倒计时终点
                nextEndTime = iosFixedDate(_ele.find('.nav_time.active').find('.time-state').attr('data-enddatetime'));
            }

            // 换成活动结束倒计时器
            this.startSwitchCountDownInit({serverTime: myMiaoServerTime, startTime: nextEndTime}, _ele);
        }
    },
    toEndtimeCallback:function(t, _ele){ // 距离结束倒计时
        if(t.total > 0 ){
            this.timeStart(t, _ele);

        } else { // 已结束
            this.timeEnd(t, _ele);
        }
    },

    // 活动开始切换结束倒计时 
    startSwitchCountDownInit(aTime, _ele){
        // 清除旧计时器,换上新的计时器
        window.MIAOV2CURACTIVETIMEVALLIST.forEach((item,index)=>{
            if(item.id == _ele.attr('id') && item.ele && item.ele.countDown){
                clearInterval(item.ele.countDown.timeInterVal);
                item.ele.countDown.init(aTime, function(t){
                    miaoV2.toEndtimeCallback(t, _ele);
                });
            }
        });
    },
    countDownInit: function(_ele, aTime){
        if(_ele.length>0){
            var userData = JSON.parse(_ele.attr('data-miao-userdata'));//控件数据
            var $miao_count=_ele.find('.js_miao_count');
            var miaoServerTime = Date.parse(new Date());
            if($miao_count[0]){
                _ele.countDown = countObj.countDown();
            }
        }
    },
    // 页面初始化秒杀模块
    miaoInit: function(){
        window.MIAOV2CURACTIVETIMEVALLIST = [];//当前激活的秒杀时段对象列表,用于清除计时器
        var _self=this;
         var   $willMiaoPoolList=$('.js-pool-miao-v2');
        if($willMiaoPoolList.length>0){
            $willMiaoPoolList.each(function(){
                let _ele = $(this);
                var miaoType=$(this).attr('data-miao-type'),
                miaoStyleType=$(this).attr('data-miao-style-type'),
                miaoIdType=$(this).attr('data-miao-id-type'),
                miaoData=JSON.parse($(this).attr('data-miao-data')),
                isShowNav=$(this).attr('data-is-show-nav'),
                styleColor=$(this).attr('data-miao-style-color'),
                userData = JSON.parse($(this).attr('data-miao-userdata'));//控件数据
                _self.miaoType=miaoType;
                _self.miaoStyleType=miaoStyleType;
                _self.styleColor=styleColor;
                $(this).html('');
                var params={
                    miao_type:miaoType,//秒殺類型 商品or 优惠券
                    type:miaoStyleType,//秒杀样式 single or Multiple
                    style_color:styleColor,//颜色 粉、红、蓝。。。
                    pc:1
                };
                let endTime = userData.miao_data[0].endtime ? userData.miao_data[0].endtime:"23:59";
                params.date=userData.miao_data[0].date;
                params.datetime=userData.miao_data[0].date+' '+userData.miao_data[0].time+':00';//秒杀开始时间
                // params.endDatetime = userData.miao_data[1]?userData.miao_data[1].date+' '+userData.miao_data[1].time+':00' : userData.miao_data[0].date + ' 23:59:59';//秒杀结束时间
                params.endDatetime=userData.miao_data[0].date+' '+endTime+':00';//秒杀结束时间
                params.pool_id=userData.miao_data[0].pool_id;
                params.length=userData.miao_data[0].pool_length;
                params.userdata = userData;
                params.shop_type = shop_type;//根据isLs配置url,改为shop_type： 1小天鹅 2生活电器 3东芝H5 ,区分是小天鹅还是生活电器还是其他
                params.miao_id_type = miaoIdType;
                params.miao_sort_type = $(this).attr('data-miao-sort-type');
                params.is_ls = isLs;
                // _self.miaoTimeArr=params.date;
                func.getMiaoPoolsData(params,fsid,function(html){
                    html='<div class="floor_bg js_miaosha_content">'+html+'</div>';
                    var $miaoPoolListHtml = $(html);
                    _ele.append($miaoPoolListHtml);
                    var miaoServerTime = Date.parse(new Date());
                    aTime= {serverTime:miaoServerTime,startTime: params.datetime};
                    _self.clickDateNav(_ele);//切换日期事件注册
                    _self.clickTimeNav(_ele);//切换时间事件注册
                    _self.countDownInit(_ele,aTime);//倒计时
                    window.MIAOV2CURACTIVETIMEVALLIST.push({
                        id:_ele.attr('id'),
                        ele:_ele,
                    });
                    if(miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))){//活动已经开始，启动结束倒计时
                        aTime= {serverTime:miaoServerTime,startTime: params.endDatetime,endTime:params.endDatetime};
                        _ele.countDown.init(aTime,function(t){//启动开始倒计时
                            miaoV2.toEndtimeCallback(t,_ele);//回调闭包保存变量_ele
                        });
                    }else{
                        aTime= {serverTime:miaoServerTime,startTime: params.datetime,endTime:params.endDatetime};
                        _ele.countDown.init(aTime,function(t){//启动开始倒计时
                            miaoV2.timeCallback(t,_ele);//回调闭包保存变量_ele
                        });
                    }
                    // countDown.init(aTime,miao.timeCallback);
                    
                    if(userData.time_nav_type == 2){ // 如果是时间类型直接切换
                      _self.getNearTime(_ele);
                    }else{
                      _self.getNearDate(_ele); // 跳转到当前日期时间tab
                    }
                })
            });
           
        }
    },
    getNearDate(_ele){ // 获取最新日期tab
        console.log(_ele);
        var curDate = new Date();
        var hour = curDate.getHours() > 9 ? curDate.getHours() :  '0' + curDate.getHours();
        var min = curDate.getMinutes() >9 ? curDate.getMinutes():'0'+curDate.getMinutes();
        var time = hour + ':' +min +':00';
        var year = curDate.getFullYear();
        var mon = curDate.getMonth()+1; 
        mon = (mon+'').length>1?mon:'0'+mon;
        // date = curDate.getDate()
        var date = curDate.getDate() > 9 ? curDate.getDate() : '0'+curDate.getDate();
        date= year+ '-' + mon + '-' + date;
        // var dateTime = date + ' ' + time;
        // var lowV = time, highV = time;
        var clickDateO;
        var lDate = '',hDate = '';
        
        _ele.find('.js_date_li').each(function(index,item){
            console.log('date:',date);
            console.log('data-date:',$(item));
            console.log('data-date:',$(item).attr('data-date'));
            if(date >= $(item).attr('data-date')){
              console.log('lDate data-date:',$(item).attr('data-date'));
              lDate = $(item);
            }else{
              if(index == _ele.find('.js_date_li').length-1 && date>$(item).attr('data-date')){
                console.log('lDate else data-date:',$(item).attr('data-date'));
                lDate = $(_ele.find('.js_date_li')[0]);
              }else{
                console.log('hDate else data-date:',$(item).attr('data-date'));
                hDate = $(item);
              }
            }
        });
        clickDateO = lDate;
        // var nonStockCount = 0; 
        // _ele.find('.js_miao_item').each(function(index,item){
        //   if($(item).attr('data-state') == 4){
        //     nonStockCount++;
        //   }
        // });
        // if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场
        //   clickDateO = lDate.next('.js_date_li').length?lDate.next('.js_date_li'):lDate;
        // }
        
        if(clickDateO){
          console.log(clickDateO);
            clickDateO.trigger('click');
        }
    },
    
    getNearTime(_ele){//获取最新时间tab
        console.log(_ele);
        var curDate = new Date();
        var hour = curDate.getHours() > 9 ? curDate.getHours() :  '0' + curDate.getHours();
        var min = curDate.getMinutes() >9 ? curDate.getMinutes():'0'+curDate.getMinutes();
        var time = hour + ':' + min +':00';
        var year = curDate.getFullYear();
        var mon = curDate.getMonth()+1;
        mon = (mon+'').length>1?mon:'0'+mon;
        var date = curDate.getDate() > 9 ? curDate.getDate() : '0'+curDate.getDate();
        date= year+ '-' + mon + '-' + date;
        var dateTime = date + ' ' + time;
        // var lowV = time, highV = time;
        var clickTimeO;
          var lTime='',hTime='';
        _ele.find('.nav_time').each(function(index,item){
           
            if(dateTime >= $(item).attr('data-datetime')){
              lTime = $(item);
            }else{
              if(index == _ele.find('.nav_time').length-1 && !lTime){//所有活动都大于当前时间，则设置第一个活动页面
                lTime = $(_ele.find('.nav_time')[0]);
              }else{
                hTime = $(item);
              }
              
            }

        });
        clickTimeO = lTime;
        // var nonStockCount = 0; //当前场已售罄商品数
        // _ele.find('.js_miao_item').each(function(index,item){
        //   if($(item).attr('data-state') == 4){
        //     nonStockCount++;
        //   }
        // });
        // if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场
        //   clickTimeO = lTime.next('.nav_time').length?lTime.next('.nav_time'):lTime;
        // }
        if(clickTimeO){

            clickTimeO.trigger('click');
        }
    },
    clickDateNav:function(_ele){//点击日期导航切换列表
        var _self=this;
        // var $willMiaoPoolList=$('.js-pool-miao');
        // if($willMiaoPoolList.length>0){
        //     $willMiaoPoolList.each(function(){
                // let _ele = $(this);
                var userData = JSON.parse(_ele.attr('data-miao-userdata')),//控件数据
                    miaoIdType=_ele.attr('data-miao-id-type');//id类型;;//控件数据
                _ele.on('click','.js_date_li',function(){
                    var That = $(this),
                        ThatDatetime = That.attr('data-datetime'),//日期
                        ThatPoolId=That.attr('data-sku-pool-id'),//商品池id
                        ThatLength=That.attr('data-length'),//商品池长度
                        miaoStyleType=That.attr('data-style-type');//秒杀样式
                    _ele.find('.nav_date_li').removeClass('active');
                    $(this).addClass('active');
                    var params={
                        miao_type:this.miaoType,//秒殺類型 商品or 优惠券
                        type:miaoStyleType,//秒杀样式 single or Multiple
                        style_color:this.styleColor,//颜色 粉、红、蓝。。。
                        'datetime':ThatDatetime,
                        'endDatetime':That.find('.time-state').attr('data-enddatetime')?That.find('.time-state').attr('data-enddatetime'): ThatDatetime.substr(0,10) + ' 23:59:59',
                        'date':ThatDatetime.substr(0,10),
                        'pool_id':ThatPoolId,
                        'length':ThatLength,
                        'shop_type' : shop_type,//根据isLs配置url,改为shop_type： 1小天鹅 2生活电器 3东芝商城 ,区分是小天鹅还是生活电器还是东芝商城H5
                        'is_ls' : isLs,
                        'pc':1,
                        'userdata':userData,
                        'miao_id_type':miaoIdType,
                        'miao_sort_type':_ele.attr('data-miao-sort-type'),
                    };
                    func.getMiaoPoolsData(params,fsid,function(html){
                        var $miaoPoolListHtml = $(html);
                        //$miaoPoolListHtml.addClass(params.style_color +" ");
                        _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
                        var miaoServerTime = Date.parse(new Date());
                        //清除旧计时器,换上新的计时器
                        aTime= {serverTime:miaoServerTime,startTime: params.datetime};
                        window.MIAOV2CURACTIVETIMEVALLIST.forEach((item,index)=>{
                            if(item.id == _ele.attr('id') && item.ele && item.ele.countDown){
                                clearInterval(item.ele.countDown.timeInterVal);
                                if(miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))){//活动已经开始，启动结束倒计时
                                    aTime= {serverTime:miaoServerTime,startTime: params.endDatetime,endTime:params.endDatetime};
                                    _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                        miaoV2.toEndtimeCallback(t,_ele);//回调闭包保存变量_ele
                                    });
                                }else{
                                    aTime= {serverTime:miaoServerTime,startTime: params.datetime,endTime:params.endDatetime};
                                    _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                        miaoV2.timeCallback(t,_ele);//回调闭包保存变量_ele
                                    });
                                }
                            }
                        });
                        var nonStockCount = 0; 
                        _ele.find('.js_miao_item').each(function(index,item){
                          if($(item).attr('data-state') == 4){
                            nonStockCount++;
                          }
                        });
                        if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场
                          console.log(That.parents('li.nav_date'));
                          console.log(That.parents('li.nav_date').next());
                          var clickDateO = That.next('.js_date_li').length?That.next('.js_date_li'):(That.parents('li.nav_date').next().length?That.parents('li.nav_date').next().find('.js_date_li'):null);
                          if(clickDateO){
                            console.log(clickDateO);
                            clickDateO.trigger('click');
                          }else{
                            _self.getNearTime(_ele);
                          }
                          
                        }else{
                          _self.getNearTime(_ele);
                        }
                        
                    });
                });
        //     });
        // }
    },
    clickTimeNav:function(_ele){//点击时间导航切换列表
        var _self=this;
        // var $willMiaoPoolList=$('.js-pool-miao');
        // if($willMiaoPoolList.length>0){
        //     $willMiaoPoolList.each(function(){
                // let _ele = $(this);
                var userData = JSON.parse(_ele.attr('data-miao-userdata')),//控件数据
                    miaoIdType=_ele.attr('data-miao-id-type');//id类型;;//控件数据;//控件数据
                _ele.on('click','.nav_time',function(){
                    var That = $(this),
                        ThatDatetime = That.attr('data-datetime'),//日期
                        ThatPoolId=That.attr('data-sku-pool-id'),//商品池id
                        ThatLength=That.attr('data-length'),//商品池长度
                        miaoStyleType=That.attr('data-style-type');//秒杀样式
                    _ele.find('.nav_date_li').removeClass('active');
                    $(this).addClass('active');
                    var params={
                        miao_type:this.miaoType,//秒殺類型 商品or 优惠券
                        type:miaoStyleType,//秒杀样式 single or Multiple
                        style_color:this.styleColor,//颜色 粉、红、蓝。。。
                        'datetime':ThatDatetime,
                        'date':ThatDatetime.substr(0,10),
                        'endDatetime':That.find('.time-state').attr('data-enddatetime')?That.find('.time-state').attr('data-enddatetime'): ThatDatetime.substr(0,10) + ' 23:59:59',
                        'pool_id':ThatPoolId,
                        'length':ThatLength,
                        'shop_type' : shop_type,//根据isLs配置url,改为shop_type： 1小天鹅 2生活电器 3东芝商城 ,区分是小天鹅还是生活电器还是东芝商城H5
                        'is_ls' : isLs,
                        'pc':1,
                        'userdata':userData,
                        'miao_id_type':miaoIdType,
                        'miao_sort_type':_ele.attr('data-miao-sort-type'),
                    };
                    func.getMiaoPoolsData(params,fsid,function(html){
                        var $miaoPoolListHtml = $(html);
                        //$miaoPoolListHtml.addClass(params.style_color +" ");
                        _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
                        var miaoServerTime = Date.parse(new Date());
                        //清除旧计时器,换上新的计时器
                        aTime= {serverTime:miaoServerTime,startTime: params.datetime};
                        window.MIAOV2CURACTIVETIMEVALLIST.forEach((item,index)=>{
                            if(item.id == _ele.attr('id') && item.ele && item.ele.countDown){
                                clearInterval(item.ele.countDown.timeInterVal);
                                if(miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))){//活动已经开始，启动结束倒计时
                                    aTime= {serverTime:miaoServerTime,startTime: params.endDatetime,endTime:params.endDatetime};
                                    _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                        miaoV2.toEndtimeCallback(t,_ele);//回调闭包保存变量_ele
                                    });
                                }else{
                                    aTime= {serverTime:miaoServerTime,startTime: params.datetime,endTime:params.endDatetime};
                                    _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                        miaoV2.timeCallback(t,_ele);//回调闭包保存变量_ele
                                    });
                                }
                            }
                        });
                        var nonStockCount = 0; //当前场已售罄商品数
                        _ele.find('.js_miao_item').each(function(index,item){
                          console.log($(item).attr('data-state'));
                          if($(item).attr('data-state') == 4){
                            console.log($(item).attr('data-state')+'==? 4');
                            nonStockCount++;
                          }
                        });
                        if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场

                          var clickTimeO = That.next('.nav_time').length?That.next('.nav_time'):null;
                          if(clickTimeO){
                              console.log(clickTimeO);
                              setTimeout(function(){
                                  console.log('setTimeout',clickTimeO);
                                  clickTimeO.trigger('click');
                              });
                            
                          }
                        }
                    });
                });
        //     });
        // }
    },
    init:function(){
        this.miaoInit();//页面初始化秒杀模块
        
        
    }

}

/*
 * 轮播图模块
 *
 *
 *
 */
var SwiperApp = {
    init:function(){
        var cssHtml = '<link rel="stylesheet" href="//g.mdcdn.cn/pc/css/act/swiper.min.css" type="text/css">';
        $('head').append(cssHtml);
        var $swiperDoms = $('.swiper-container');
        var mySwiperList = [];
        $swiperDoms.each(function(index,item){
            let swiperHeight = $(item).attr('swiperHeight');
            mySwiperList[index] = new Swiper('#'+$(item).attr('id'),{
                direction:'horizontal',
                loop: true,
                height:swiperHeight,
                // autoplay: {
                //   delay: 3000,
                //   stopOnLastSlide: false,
                //   disableOnInteraction: false,
                // },
                autoplay:3000,
                // // 如果需要滚动条
                // scrollbar: {
                //   el: '.swiper-scrollbar',
                // },
            })
        });
        
    }
}

//ss mock
// var mockjs=require('../../p_mab_build/lib/fake_mock');
// mockjs.mock();
//ee mock
var serverTime=window.serverTime?window.serverTime:Date.parse(new Date());

// 输出结果
// console.log(JSON.stringify(data, null, 4))
//eeemock
function strtotime(date) {
    // var date="2014-05-08 00:22:11";//unix*1000
    date = new Date(Date.parse(date.replace(/-/g, "/")));
    date = date.getTime();
    return date;
}


 /**
   * @desc 预售初始化
   */
var Presell ={
  eventBind(){
    $(document).on('click','.js_presell_coupon_btn',function(){//绑定领券按钮
      let self = this;
          var oid = $(this).attr('couponid');
          var $this = $(this);

          login.start(function(){

              // 防频繁点击
              if($this.attr('data-clicked') == 1){
                  return;
              }
              $this.attr('data-clicked', 1);

              $.ajax({
                  type: 'GET',
                  url: '/coupon/get_user_coupon',
                  data: {obtainId: oid},
                  timeout: 10000,
                  dataType: 'json',
                  success: function (data) {
                      var errCode = data.errcode;
                      if (errCode == 0) {
                          coupon.popAll('getSuc');
                      } else if (errCode == 549064771) {  //还没到领取时间
                          coupon.popAll('getNotTime');
                      }else if (errCode == 549064739) {  //已抢过
                          coupon.popAll('getDone');
                      }else if (errCode == 549064758 || errCode == 549064802) {  //已抢光 | 已暂停
                          coupon.popAll('getNone');
                      }else {
                          coupon.popAll('getFailed');   //领券过于频繁，系统繁忙
                      }
                  },
                  error: function () {
                      coupon.popAll('getFailed');
                  },
                  complete: function () {
                      $this.attr('data-clicked', 0);
                  }
              });
          }, function(){});
    });
  },
  init(){
    this.eventBind();
  },
}

/**
 * @desc 秒杀券模块
 */
var miao_coupon = {
    url:'/promote/w/mabapp/',
    /**
     * @desc 注册领取积分优惠券事件
     */
    couponExchangeScore () {
        var that = this;
        $('.js_get_ms_score_coupon').on('click', function (e) {
            e.stopPropagation();
            var $this = $(this);
            var bid = $this.attr('data-bid');
            var num = $this.attr('data-num');

            var self = this;
            login.start(function () {
                $.mpopup({
                    type: 'confirmV2',
                    icoType: '', // icoType 图标 info / right / 空
                    content: '<div style="text-align: center">您确定消费' + num + '积分兑换该券吗?</div>',
                    destroyAfterClose: false,
                    buttons: [
                        {tpl: '<a class="mod_popup_btn" data-mpopup-confirm href="javascript:void(0)">好的</a>'},
                        {tpl: '<a class="mod_popup_btn" data-mpopup-close href="javascript:void(0)">关闭</a>'}
                    ],
                    onConfirm: function () {
                        that.getCoupon(bid, self);
                    }
                }).show();
            }, function () {});
        });
    },
    /**
     * @desc 领取积分优惠券
     * @params self 领券按钮
     */
    getCoupon (bid, self) {
        let that = this;
        let num = $(self).attr('num');

        let act_id = parseInt($(self).parents('.js_mc_section').data('actid'));        // 活动 id
        let detail_id = parseInt($(self).parents('.js_mc_section').data('actdetail')); // 活动详情 id
        let $this = $(self);

        if($this.attr('data-clicked') == 1){
            return;
        }
        $this.attr('data-clicked', 1);

        $.ajax({
            type: 'POST',
            url: that.url + 'get_user_score_coupon',
            data: {
                act_id,
                detail_id
            },
            timeout: 10000,
            dataType: 'json',
            success (data) {
                var errCode = data.errcode;
                if (errCode == 0) {
                    coupon.popAll('getScoreSuc');

                } else if (errCode == 549064739) {
                    coupon.popAll('getScoreDone');

                } else if (errCode == 1001) {          // 积分不足
                    coupon.popAll('getScoreNotTime');

                }else if (errCode == 549064771) {      // 还没到领取时间
                    coupon.popAll('getNotTime');

                }else if (errCode == 549064739) {      // 已抢过
                    coupon.popAll('getDone');

                }else if (errCode == 549064758 || errCode == 549064802) {  // 已抢光 | 已暂停
                    coupon.popAll('getNone');

                } else {
                    coupon.popAll('getScoreFailed');   // 领券过于频繁，系统繁忙
                }
            },
            error: function () {
                coupon.popAll('getScoreFailed');
            },
            complete:function () {
                $(self).attr('data-clicked', 0);
            }
        });
    },
    /**
     * @desc 注册领取普通优惠券事件
     */
    getMsCoupon () {
        let that = this;
        $('.js_get_ms_coupon').on('click', function(){
            let self = this;
            var oid = $(this).attr('data-oid');
            var $this = $(this);

            login.start(function(){

                // 防频繁点击
                if($this.attr('data-clicked') == 1){
                    return;
                }
                $this.attr('data-clicked', 1);

                $.ajax({
                    type: 'GET',
                    url: '/coupon/get_user_coupon',
                    data: {obtainId: oid},
                    timeout: 10000,
                    dataType: 'json',
                    success: function (data) {
                        var errCode = data.errcode;
                        if (errCode == 0) {
                            coupon.popAll('getSuc');
                        } else if (errCode == 549064771) {  //还没到领取时间
                            coupon.popAll('getNotTime');
                        }else if (errCode == 549064739) {  //已抢过
                            coupon.popAll('getDone');
                        }else if (errCode == 549064758 || errCode == 549064802) {  //已抢光 | 已暂停
                            coupon.popAll('getNone');
                        }else {
                            coupon.popAll('getFailed');   //领券过于频繁，系统繁忙
                        }
                    },
                    error: function () {
                        coupon.popAll('getFailed');
                    },
                    complete: function () {
                        $this.attr('data-clicked', 0);
                    }
                });
            }, function(){});
        });
    },
    /**
     * @desc 注册倒计时
     * @params that 倒计时dom
     */
    msTimeEvent (startTime, that) {
        let timer = countObj.countDown();
        let timerConfig = {
            serverTime: serverTime,
            startTime: startTime
        };

        timer.init(timerConfig, function(t){
            if(t.total >= 0){
                let $count = $(that);
                $count.find('.js_day').text(t.days);
                $count.find('.js_hour').text(t.hours);
                $count.find('.js_min').text(t.minutes);
                $count.find('.js_sec').text(t.seconds);
                if(t.total == 0){
                    $(that).parents('.js_mc_section').removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').addClass('mc_sec_on_going');
                }
            }else{
                clearInterval(t.obj.timeInterVal);
            }
        });
    },
    /**
     * @desc 查询是否vip积分减半
     */
    halfScoreInit(){
        let that = this;
        $.ajax({
            type: 'GET',
            url: that.url + 'get_user_half_score',
            data: {},
            timeout: 10000,
            dataType: 'json',
            success: function(data) {
                var errCode = data.errcode;
                if (errCode == 0) {
                    if (data.halfScore == 1) {

                        let $d = $('.js_cost_score'); // 找到所有积分dom
                        $d.each(function () {
                            let $t = $(this);
                            let originalScore = parseInt($t.text());
                            let halfScore = parseInt(originalScore / 2);
                            $t.html(halfScore);
                            $t.parents('.js_coupon_info').attr('data-num', halfScore);
                        });
                    }
                }
            },
            error: function() {
                //不做处理
            }
        });
    },

    /**
     * @desc 查询秒杀券详情
     */
    queryMsCouponInfo(act_id, $this){
        let that = this;
        let actDetailId = $this.data('actdetail');
        // 请求秒杀券初始化的状态
        $.ajax({
            url:that.url + 'get_ms_coupon_info',
            type: 'post',
            data: {
                act_id
            },
            timeout: 10000,
            dataType: 'json',
            success: function (res) {
                console.log(res);
                if (res.errcode==0) {
                    // 拉取实时状态
                    let couponArr = res.couponInfo || [];
                    couponArr.forEach(function (item) {
                        if(actDetailId == item.detailId){
                          // 如果有需要显示几点开始的dom，就把开始时间显示在dom中
                          if (document.getElementsByClassName('startTime').length > 0) {
                              let startHour = item.start_time.split(' ')[1].split(':')[0];
                              $this.find(".startTime").html(startHour + '点开抢');
                          }

                          // 1. 倒计时上面记录开始时间
                          let $time = $this.find('.js_ms_time_wrap');
                          $time.attr('data-start-time', item.start_time).attr('data-stamp',strtotime(item.start_time));

                          //2. 状态渲染: 1、未开始 2、即将开始 3、立即秒杀 4、已结束（已秒完）
                          let stateVal = parseInt(item.coupon_state);
                          switch (stateVal){
                              case 1:
                                  $this.removeClass('mc_sec_over').removeClass('mc_sec_will_start').removeClass('mc_sec_on_going').addClass('mc_sec_un_start');
                                  that.msTimeEvent(item.start_time, $time);
                                  break;
                              case 2:
                                  $this.removeClass('mc_sec_over').removeClass('mc_sec_un_start').removeClass('mc_sec_on_going').addClass('mc_sec_will_start');
                                  that.msTimeEvent(item.start_time, $time);
                                  break;
                              case 3:
                                  $this.removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').removeClass('mc_sec_over').addClass('mc_sec_on_going');
                                  break;
                              default:
                                  $this.removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').removeClass('mc_sec_on_going').addClass('mc_sec_over');
                                  break;
                          }
                        }
                        
                    })
                }
            },
            fail: function(res) {
                // 拉取实时状态
                console.log(res);
            },
            complete: function(res) {
                console.log(res);
            }
        })
    },

    /**
     * @desc 优惠券状态初始化
     */
    couponStateInit(){
        let that = this;
        let $d = $('.js_coupon_info'); // 所有的领取按钮

        // 批次id数组
        let bidArr = [];
        $d.each(function(i){
            let $this = $(this);
            bidArr.push($this.data('bid'))
        });

        // 活动id数组
        let actidArr = [];
        let $p = $('.js_mc_section');
        $p.each(function(i){
            let $this = $(this);
            actidArr.push($this.data('actid'))
            that.queryMsCouponInfo($this.data('actid'), $this)
        });
        if(actidArr.length <= 0){
            return;
        }
    },
    /**
     * @desc 优惠券初始化
     */
    pageInit(){
        if(isLs == 0){//小天鹅不用
          this.halfScoreInit();  // 是否vip积分减半
        }
        
        this.couponStateInit() // 优惠券状态初始化
    },

    /**
     * @desc 页面初始化
     */
    init(){
        // this.countDownInit();    // 倒计时初始化
        this.pageInit();            // 优惠券信息渲染初始化
        this.getMsCoupon();         // 注册普通秒杀券领取事件
        this.couponExchangeScore(); // 注册秒杀积分券领取事件
    },
    /**
     * @desc 已弃用
     */
    countDownInit(){
        let that=this;
        $('.js_ms_time_wrap').each(function(){
            var _this=this;
            var time=$(_this).attr('data-start-time'),
                timeStamp=$(_this).attr('data-stamp');
            var current=new Date().getTime();
            if(parseInt(timeStamp)>current){//活动还未开始
                that.msTimeEvent(time,_this);
            }else{
                // 活动正在进行中
                $(_this).parents('.js_mc_section').removeClass('mc_sec_will_start').removeClass('mc_sec_un_start').addClass('mc_sec_on_going')
            }
        });

    }
};
/**
 * @desc 卖场倒计时
 */
var PageCountTime = {
  init(){
    const that = this;
    var pageData = $('#pageDataCache').attr('data-pageconf')?JSON.parse($('#pageDataCache').attr('data-pageconf')):{};
    if(pageData && pageData.is_show_counting_time == 1){//展示卖场倒计时
      let strDom = '<div class="counting_time_box js_counting_time hide">'+
                      '<div class="counting_time-content">'+
                        '距离活动开始还有0天0时0分0秒'+
                      '</div>'+
                    '</div>';
      if($('.event_mod_lift_style_3.h5_top').length>0){//如果存在顶部导航栏
        $('.event_mod_lift_style_3').append(strDom);
        $('body').addClass('content_lift-show_coutting_time');
      }else{
        $('body').prepend(strDom);
        $('.counting_time_box').addClass('fixed');
        $('body').addClass('content-show_coutting_time');
        
      }
      setTimeout(function(){
        $('.js_counting_time').removeClass('hide');
          let offTimeStamp = new Date(iosFixedDate(pageData['offline_time'])).getTime();
          let onlineTimeStamp = new Date(iosFixedDate(pageData['online_time'])).getTime();
          let nowTimeStamp = new Date().getTime();
          if(onlineTimeStamp > nowTimeStamp){
              setInterval(function(){that.updategetYMDhms(nowTimeStamp,iosFixedDate(pageData['online_time']),'开始')},1000);
          }else if(offTimeStamp > nowTimeStamp){
              setInterval(function(){that.updategetYMDhms(nowTimeStamp,iosFixedDate(pageData['offline_time']),'结束')},1000);
          }else{

          }
      });
    }
  },
  //计算倒计时
  count : 0,
  updategetYMDhms:function(start, end, type) {
      this.count += 1;//该方法执行几次，count相应++
      var date1 = new Date(start);
      var date2 = new Date(end);
      var s1 = date1.getTime();
      var s2 = date2.getTime();//毫秒为单位
      var total = (s2 - s1) / 1000 - this.count;//每执行一次，减少时间差-1
      var day = parseInt(total / (24 * 60 * 60)); //计算整数天数
      var afterDay = total - day * 24 * 60 * 60; //取得算出天数后剩余的秒数
      var hour = parseInt(afterDay / (60 * 60)); //计算整数小时数
      var afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60; //取得算出小时数后剩余的秒数
      var min = parseInt(afterHour / 60); //计算整数分
      var afterMin = total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60;
      var second = parseInt(afterMin); //计算整数秒
      let textRes = '距离活动'+type+'还有';
      // if(day > 3){
      //     $('.counting_time-content').text(textRes + day + ' 天 ');
      // }else if(day == 0){
          $('.counting_time-content').text(textRes + day + ' 天 ' + hour + ' 时 ' + min + ' 分 ' + second + ' 秒');
      // }

  }
}


var initialize = function(){
  product.init();
  lazy.init_bg();
  lazy.init_pool();
  lift.init();
  coupon.init(); //优惠券相关
  giftPack.init();//giftPack
  rule.init();//活动规则相关
  cart.init(); //加入购物车相关
  miaoV2.init();//秒杀二期
  miao_coupon.init();//秒杀优惠券
  SwiperApp.init();//轮播图
  Presell.init();//预售
  linkPopLayer.init();//弹窗
  PageCountTime.init();//页面倒计时
  widgetVipcard.init({login:login});//会员卡
  
  widgetMiaoCouponlist.init();//秒杀优惠券列表
  widgetCouponlist.init();//优惠券列表
  $('#link-1572441144402,#link-1572441149842').on('click',function(){//临时代码到期删掉
      if($(this).attr('id') == 'link-1572441149842'){
        alert('很遗憾，由于金勋章点亮目标未完成，抽奖开放需延期~');
      }
      if($(this).attr('id') == 'link-1572441144402'){
        alert('很遗憾，由于银勋章点亮目标未完成，周边开放需延期~');
      }

  })
};
var LoadingWrap = {
  operateLoading : function(type){//控制loading显示或者隐藏
      var $loader_wrap = $(".loader_wrap");
      if(type == 'show'){
          $loader_wrap.addClass("show");
      }else{
          $loader_wrap.removeClass("show");
      }
  },

}
// initialize();
/*
* @desc 页面配置控制
*
**/
var PageManage = {
  init:function(){
    try{
      LoadingWrap.operateLoading('show');
      var pageData = $('#pageDataCache').attr('data-pageconf')?JSON.parse($('#pageDataCache').attr('data-pageconf')):{};
      if(pageData.offline_time){
          pageData.offline_time = pageData.offline_time.replace(/-/g,'/');//兼容IOS
      }
      if(pageData.offline_time && new Date(pageData.offline_time).getTime() - serverTime <= 0){
        if($('.md-popup').length==0){
          var data = {
            title:'',
            content:'目前该卖场已经下线啦~,正在为您跳转到指定页面.....',
            btnConfirmTxt:'好的~~',
          };
          var output = dialogTpl(data);
          $('body').append(output);
        }else if($('.md-popup').length>0){
          $('.md-popup').addClass('md-popup-in');
          $('.md-popup-backdrop').addClass('md-active');
        }
        setTimeout(function(){
          location.href = pageData.offline_url?pageData.offline_url:'//m.midea.cn';
        },2000)
      }else{
        initialize();
      }
      LoadingWrap.operateLoading('hide');
    }catch(e){
      alert(e);
    }
    
  }
}

  wx.miniProgram.getEnv(function(res) { 
   
    window.IsWxMiniProgram = res.miniprogram;
    console.log(res.miniprogram);
    if(!hasInitOnce){
      PageManage.init();
      hasInitOnce = true;
    }
  });

  if(!hasInitOnce){//是否已经初始化过了
    PageManage.init();
    hasInitOnce = true;
  }
}catch(e){
  alert('err');
  alert(e);
}
// setTimeout(PageManage.init,0);//保证wxEnv执行在前/


// WEBPACK FOOTER //
// ./pages/app.js